import React, { useState, useImperativeHandle, forwardRef } from "react";
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import mydata_help1 from '../../img/mydata_help1.jpg';
import mydata_help2 from '../../img/mydata_help2.jpg';
import mydata_help3 from '../../img/mydata_help3.jpg';
import mydata_help4 from '../../img/mydata_help4.jpg';
import mydata_help5 from '../../img/mydata_help5.jpg';
import mydata_help6 from '../../img/mydata_help6.jpg';
import mydata_help7 from '../../img/mydata_help7.jpg';
import mydata_help8 from '../../img/mydata_help8.jpg';

const MYDATA_URL = "https://www1.aade.gr/saadeapps2/bookkeeper-web";

const MyDataHelpModal = forwardRef((_props, ref) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setShow(true),
        close: () => setShow(false),
    }));

    const steps = [
        {
            text: (
                <>
                    {t('mydataHelpStep1')}{' '}
                    <a href={MYDATA_URL} target="_blank" rel="noreferrer">{MYDATA_URL}</a>
                </>
            ),
            img: mydata_help1,
        },
        { text: t('mydataHelpStep2'), img: mydata_help2 },
        { text: t('mydataHelpStep3'), img: mydata_help3 },
        { text: t('mydataHelpStep4'), img: mydata_help4 },
        { text: t('mydataHelpStep5'), img: mydata_help5 },
        { text: t('mydataHelpStep6'), img: mydata_help6 },
        { text: t('mydataHelpStep7'), img: mydata_help7 },
        { text: t('mydataHelpStep8'), img: mydata_help8 },
    ];

    return (
        <Modal
            size="xl"
            centered
            scrollable
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className="mydata-help-modal-header">
                <Modal.Title>
                    <i className="fa fa-database" style={{ marginRight: 10 }}></i>
                    {t('mydataHelpTitle')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mydata-help-modal-body">
                {steps.map((step, i) => (
                    <div key={i} className="mydata-help-step mb-3">
                        <div className="mydata-help-step-header">
                            <span className="mydata-help-step-number">{i + 1}</span>
                            <span className="mydata-help-step-text">{step.text}</span>
                        </div>
                        <div className="mydata-help-step-img">
                            <img src={step.img} alt={`step-${i + 1}`} />
                        </div>
                    </div>
                ))}
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-skin" onClick={() => setShow(false)}>OK</button>
            </Modal.Footer>
        </Modal>
    );
});

export default MyDataHelpModal;
